import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import { VOCABO_MEASURE } from '../../../../constants/shared/MeasuresConstants';
import BDProbeDetails from './BDProbeDetails';
import TQVMProbeDetails from './TQVMProbeDetails';
import FITBProbeDetails from './FITBProbeDetails';
import Spinner from '../../../../components/spinner/Spinner';

const { FITB, BD, TQVM } = VOCABO_MEASURE;

const VocaboSubmeasuresProbeDetailsBody = ({ content, result, isFormFetching, fetchFormData }) => {
    useEffect(() => {
        if (!isFormFetching && isEmpty(content)) {
            fetchFormData();
        }
    });

    if (isEmpty(content)) {
        return <Spinner />;
    }
    switch (result.measure) {
        case FITB:
            return <FITBProbeDetails result={result} content={content} />;
        case BD:
            return <BDProbeDetails result={result} content={content} />;
        case TQVM:
            return <TQVMProbeDetails result={result} content={content} />;
        default:
            return null;
    }
};

VocaboSubmeasuresProbeDetailsBody.defaultProps = {
    result: {},
    content: {},
    isFormFetching: false,
    fetchFormData: () => {},
};

VocaboSubmeasuresProbeDetailsBody.propTypes = {
    result: PropTypes.object,
    content: PropTypes.object,
    isFormFetching: PropTypes.bool,
    fetchFormData: PropTypes.func,
};

export default VocaboSubmeasuresProbeDetailsBody;
